import {
  Directive,
  effect,
  ElementRef,
  inject,
  model,
  Renderer2,
  RendererStyleFlags2,
} from '@angular/core';

import type { SupportedThemes, Theme } from '@core/theme-util';
import { tokenToCssVar } from '@core/utils-legacy';

type IconSpecificTokenExtract<T> = Extract<T, `colorIcon${string}` | `misc${string}`>;
type ExtractedIconToken = IconSpecificTokenExtract<keyof Theme>;

export type IconToken = ExtractedIconToken extends never
  ? IconSpecificTokenExtract<keyof typeof SupportedThemes.light>
  : ExtractedIconToken;

@Directive({
  selector: '[iconColor]',
  exportAs: 'iconColor',
  host: {
    '[class.icon-color-token]': '!!iconColor()',
  },
})
export class IconColorDirective {
  private readonly renderer = inject(Renderer2);
  private readonly CSS_TOKEN = '--icon-color-token';

  public readonly elementRef = inject(ElementRef);

  public iconColor = model<IconToken | undefined>();

  private watchIconColor = effect(() => {
    const token = this.iconColor();
    const flags = RendererStyleFlags2.Important + RendererStyleFlags2.DashCase;
    const { nativeElement } = this.elementRef;
    if (token) {
      this.renderer.setStyle(nativeElement, this.CSS_TOKEN, tokenToCssVar(token), flags);
    } else {
      this.renderer.removeStyle(nativeElement, this.CSS_TOKEN, flags);
    }
  });
}
